<div class="account-shell__content">
  <div class="row">
    <div class="pg-wrapper">
      <div class="account-shell__content-wrapper"
        ngClass="{{(deviceValue | async) === DTypes.Mobile ? '' : 'pl-3 pr-3'}}">

        <div class="performers-create__content">
          <div class="performers-create__content-wrapper">

        <p class="ui-input__error performers-create__global-error" *ngIf="globalError">
          {{ globalError }}
        </p>

        <div class="performers-create__prefill" *ngIf="PrefillBulletins.length">
          <div class="performers-create__content-subtitle">
            <h5>Предзаполнить из объявления</h5>
            <p class="txt-caption__large">Выберите объявление из раздела «Поиск музыканта», чтобы подставить данные в форму.</p>
          </div>
          <div class="grid align-items-center">
            <div class="col-4 col-sm-12">
              <select class="ui-input" [(ngModel)]="prefillBulletinId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">Не выбирать</option>
                <option *ngFor="let b of PrefillBulletins" [ngValue]="b.id">{{ b.performer || 'Объявление #' + b.id }}</option>
              </select>
            </div>
            <div class="col-auto">
              <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onPrefillFromBulletin()">
                Подставить данные
              </button>
            </div>
          </div>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off" class="performers-create__form">

          <div class="performers-create__content-subtitle"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">
            <h5>Общая информация</h5>
          </div>

          <div class="grid"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column align-items-center performers-create__first-grid' : 'align-items-start'}}">

            <div class="col-4 col-sm-12"
              id="performers-create-field-cityId"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__first-grid-col pl-2 pr-2' : 'pl-0 pr-2'}}">
              <div class="ui-input__placeholder">
                <p>Город</p>
                <span class="require">*</span>
              </div>
              <p-dropdown
                optionLabel="name"
                [filter]="true"
                [options]="Cities"
                [(ngModel)]="CitySelected"
                [ngModelOptions]="{standalone: true}"
                [styleClass]="form.get('cityId').invalid && form.get('cityId').touched ? 'p-dropdown__bulletins error' : 'p-dropdown__bulletins'"
                (onChange)="onCityDropdownChange()"
                filterPlaceholder="Поиск города..."
                emptyFilterMessage="Ничего не нашли...">
              </p-dropdown>
            </div>

            <div class="col-4 col-sm-12"
              id="performers-create-field-name"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__first-grid-col pl-2 pr-2' : 'pl-2 pr-2'}}">
              <div class="ui-input__placeholder">
                <p>Имя / псевдоним</p>
                <span class="require">*</span>
              </div>
              <div class="ui-input ui-input__text" [class.error]="form.get('name').invalid && form.get('name').touched">
                <input type="text" formControlName="name" placeholder="Руки вверх" maxlength="200">
              </div>
              <p class="ui-input__error" *ngIf="form.get('name').invalid && form.get('name').touched">
                Обязательное поле, от 1 до 200 символов
              </p>
            </div>

            <div class="col-4 col-sm-12"
              id="performers-create-field-slug"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__first-grid-col pl-2 pr-2' : 'pl-2 pr-2'}}">
              <div class="ui-input__placeholder">
                <p>Адрес страницы</p>
                <span class="require">*</span>
              </div>
              <div class="ui-input ui-input__text" [class.error]="form.get('slug').invalid && form.get('slug').touched">
                <input type="text" formControlName="slug" placeholder="muzrus.com/" maxlength="100" (input)="onSlugInput($any($event.target).value)">
              </div>
              <p class="txt-caption performers-create__slug-preview">{{ slugPreviewUrl }}</p>
              <p class="ui-input__error" *ngIf="form.get('slug').invalid && form.get('slug').touched">
                {{ form.get('slug').errors?.required ? 'Укажите адрес страницы' : (form.get('slug').errors?.slugTaken ? 'Этот адрес страницы уже занят' : 'Только строчные латинские буквы, цифры и дефисы, 3–100 символов') }}
              </p>
            </div>
          </div>

          <div class="performers-create__field performers-create__field--gap-top" id="performers-create-field-biography">
            <div class="ui-input__placeholder">
              <p>Биография</p>
              <p class="error-holder" *ngIf="form.get('biography').invalid && form.get('biography').touched">
                {{ form.get('biography').errors?.maxlength ? 'Не более 5000 символов' : '' }}
              </p>
            </div>
            <div class="ui-input ui-input__text" [class.error]="form.get('biography').invalid && form.get('biography').touched">
              <textarea
                placeholder="Расскажите о вас"
                formControlName="biography"
                maxlength="5000"
                rows="5"></textarea>
            </div>
            <p class="pt-1 txt-helper">Доступно символов для ввода: {{ biographyLimit }}</p>
          </div>

          <div class="performers-create__field" id="performers-create-field-genreIds">
            <div class="ui-input__placeholder">
              <p>Жанр или стиль</p>
              <span class="require">*</span>
            </div>
            <div class="ui-input ui-input__text">
              <div class="ui-input__cup cta ui-scroll-horizontal" (click)="openGenreSearch()"
                [class.error]="form.get('genreIds').invalid && form.get('genreIds').touched">
                <span *ngIf="!GenresSelected.length">
                  Выбрать жанр или стиль
                </span>
                <div class="grid align-items-center flex-nowrap" *ngIf="GenresSelected.length">
                  <ng-container *ngFor="let genre of GenresSelected">
                    <p-chip [label]="genre.name" styleClass="input__chip"></p-chip>
                  </ng-container>
                </div>
              </div>
            </div>
            <p class="ui-input__error" *ngIf="form.get('genreIds').invalid && form.get('genreIds').touched">
              Выберите от 1 до 5 жанров
            </p>
          </div>

          <div class="performers-create__field" id="performers-create-field-performerTypes"
            [class.error]="showPerformerTypesError">
            <div class="ui-input__placeholder">
              <p>Типы исполнителя</p>
              <span class="require">*</span>
            </div>
            <p class="txt-caption">Можно выбрать не более 3 одновременно</p>
            <p class="ui-input__error" *ngIf="showPerformerTypesError">
              Выберите от 1 до 3 типов исполнителя
            </p>
            <div class="grid performers-create__types-grid mt-4 mb-4"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column align-items-center' : ''}}">
              <ng-container *ngFor="let t of PerformerTypes">
                <div class="col-3 col-sm-12"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pb-2 pl-2 pr-2' : 'pb-4 pr-2'}}">
                  <div class="ui-checkbox" [class.disabled]="isPerformerTypeDisabled(t.value)">
                    <input [id]="'performerType_' + t.value" type="checkbox"
                      [checked]="isPerformerTypeSelected(t.value)"
                      [disabled]="isPerformerTypeDisabled(t.value)"
                      (change)="togglePerformerType(t.value)">
                    <label [attr.for]="'performerType_' + t.value">
                      <span class="ui-checkbox__text">{{ t.name }}</span>
                    </label>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="performers-create__field" id="performers-create-field-hashtagsRaw">
            <div class="ui-input__placeholder">
              <p>Хештеги</p>
            </div>
            <p class="txt-caption mb-4">До 10 штук, каждый от 3 до 20 символов включительно. Например: #rock #house</p>
            <div class="ui-input ui-input__text">
              <input type="text" formControlName="hashtagsRaw" placeholder="#rock #house" (input)="onHashtagsInput()" (blur)="onHashtagsBlur()">
            </div>
            <p class="ui-input__error" *ngIf="showHashtagLimitMessage">Допустимо не более 10 хештегов</p>
            <p class="ui-input__error" *ngIf="form.get('hashtags').invalid && form.get('hashtags').touched && !showHashtagLimitMessage">Каждый хештег: от 3 до 20 символов (латинские буквы, цифры, подчёркивание)</p>
          </div>

          <div class="performers-create__content-subtitle mt-8"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">
            <h5>Ссылки на соцсети</h5>
          </div>

          <div class="performers-create__field" id="performers-create-field-socialLinks">
            <div formArrayName="socialLinks">
              <div *ngFor="let c of socialLinksArray.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i" class="performers-create__social-row"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__first-grid-col' : ''}}">
                <div class="performers-create__social-platform"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pl-2 pr-2' : 'pr-2'}}">
                  <p-dropdown
                    [options]="SocialPlatforms"
                    optionLabel="name"
                    optionValue="value"
                    [formControl]="c.get('platform')"
                    styleClass="p-dropdown__bulletins"
                    [placeholder]="'Платформа'"
                    [showClear]="false">
                    <ng-template let-platform pTemplate="item">
                      <div class="performers-create__platform-option">
                        <span *ngIf="getPlatformIcon(platform.value).type === 'font'" [class]="getPlatformIcon(platform.value).iconClass" class="performers-create__platform-icon-font">
                          <span class="path1"></span><span class="path2"></span><span class="path3" *ngIf="getPlatformIcon(platform.value).paths >= 3"></span><span class="path4" *ngIf="getPlatformIcon(platform.value).paths >= 4"></span>
                        </span>
                        <img *ngIf="getPlatformIcon(platform.value).type === 'svg'" [src]="getPlatformIcon(platform.value).src" class="performers-create__platform-icon-img" alt="">
                        <span class="performers-create__platform-name">{{ platform.name }}</span>
                      </div>
                    </ng-template>
                    <ng-template let-platform pTemplate="selectedItem">
                      <div class="performers-create__platform-option" *ngIf="platform; else platformPlaceholder">
                        <span *ngIf="getPlatformIcon(platform.value).type === 'font'" [class]="getPlatformIcon(platform.value).iconClass" class="performers-create__platform-icon-font">
                          <span class="path1"></span><span class="path2"></span><span class="path3" *ngIf="getPlatformIcon(platform.value).paths >= 3"></span><span class="path4" *ngIf="getPlatformIcon(platform.value).paths >= 4"></span>
                        </span>
                        <img *ngIf="getPlatformIcon(platform.value).type === 'svg'" [src]="getPlatformIcon(platform.value).src" class="performers-create__platform-icon-img" alt="">
                        <span class="performers-create__platform-name">{{ platform.name }}</span>
                      </div>
                      <ng-template #platformPlaceholder>Платформа</ng-template>
                    </ng-template>
                  </p-dropdown>
                </div>
                <div class="performers-create__social-url"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pl-2 pr-2' : 'pl-2 pr-2'}}">
                  <div class="ui-input ui-input__text" [class.error]="c.get('url').invalid && c.get('url').touched">
                    <input type="url" formControlName="url" placeholder="https://">
                  </div>
                </div>
                <div class="performers-create__social-remove">
                  <button type="button" class="ui-buttons ui-buttons__light-small performers-create__social-remove-btn" (click)="removeSocialLink(i)" [attr.aria-label]="'Удалить ссылку'">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <button type="button" class="ui-buttons ui-buttons__light-small performers-create__add-link-btn mt-2" (click)="addSocialLink()">Добавить ссылку</button>
          </div>

          <div class="performers-create__content-subtitle mt-8"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">
            <h5>Фото и видео</h5>
          </div>

          <div class="performers-create__field" formArrayName="videoLinks" id="performers-create-field-videoLinks">
            <div class="grid"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'align-items-end'}}">
              <div class="col-6 col-sm-12 performers-create__video-col"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pb-2' : 'pr-2'}}">
                <div class="ui-input__placeholder">
                  <p>Ссылка на видео VK</p>
                </div>
                <div class="ui-input ui-input__text" [class.error]="videoLinksArray.controls[0].invalid && videoLinksArray.controls[0].touched">
                  <div class="ui-input__helper">
                    <div class="ui-input__helper-icon performers-create__vk-video-icon">
                      <img src="assets/images/icons/vk-video.svg" alt="VK Video" />
                    </div>
                  </div>
                  <input type="url" [formControlName]="0" placeholder="https://vk.com/video123456789_123456789">
                </div>
                <div class="performers-create__video-error">
                  <p class="ui-input__error" *ngIf="videoLinksArray.controls[0].invalid && videoLinksArray.controls[0].touched">
                    Укажите ссылку на VK видео
                  </p>
                </div>
              </div>
              <div class="col-6 col-sm-12 performers-create__video-col"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__video-second-col pb-2' : 'pl-2 pr-0'}}">
                <div class="ui-input__placeholder">
                  <p>Ссылка на дополнительное видео VK</p>
                </div>
                <div class="ui-input ui-input__text" [class.error]="videoLinksArray.controls[1].invalid && videoLinksArray.controls[1].touched">
                  <div class="ui-input__helper">
                    <div class="ui-input__helper-icon performers-create__vk-video-icon">
                      <img src="assets/images/icons/vk-video.svg" alt="VK Video" />
                    </div>
                  </div>
                  <input type="url" [formControlName]="1" placeholder="https://vk.com/video123456789_123456789">
                </div>
                <div class="performers-create__video-error">
                  <p class="ui-input__error" *ngIf="videoLinksArray.controls[1].invalid && videoLinksArray.controls[1].touched">
                    Укажите ссылку на VK видео
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="performers-create__field">
            <div class="ui-input__placeholder">
              <p>Основное фото</p>
            </div>
            <div class="performers-create__avatar">
              <div
                class="performers-create__main-photo-zone"
                [class.performers-create__main-photo-zone--empty]="!MainPhotoPreview"
                [class.performers-create__main-photo-zone--filled]="MainPhotoPreview"
                [class.performers-create__main-photo-zone--dragover]="mainPhotoDragOver"
                (click)="!MainPhotoPreview && mainPhotoInput.click()"
                (dragover)="!MainPhotoPreview && onMainPhotoDragOver($event)"
                (dragleave)="onMainPhotoDragLeave($event)"
                (drop)="!MainPhotoPreview && onMainPhotoDrop($event)"
              >
                <ng-container *ngIf="!MainPhotoPreview">
                  <div class="performers-create__main-photo-zone-inner">
                    <div class="performers-create__main-photo-zone-icon">
                      <i class="pi pi-upload"></i>
                    </div>
                    <p class="performers-create__main-photo-zone-text">Загрузить основное фото</p>
                    <p class="txt-caption performers-create__main-photo-zone-hint">До 1 Мб. Допустимые форматы: PNG, JPG, JPEG.</p>
                  </div>
                </ng-container>
                <img *ngIf="MainPhotoPreview" [src]="MainPhotoPreview" alt="Превью" class="performers-create__main-photo-preview" />
                <button *ngIf="MainPhotoPreview" type="button" class="performers-create__gallery-item-remove" (click)="clearMainPhoto(); $event.stopPropagation()" [attr.aria-label]="'Удалить фото'">
                  <i class="pi pi-times"></i>
                </button>
              </div>
              <input
                type="file"
                class="performers-create__file-input"
                #mainPhotoInput
                accept="image/png,image/jpeg,image/jpg"
                (change)="onMainPhotoChange($event.target.files)"
              />
              <p class="txt-caption performers-create__avatar-hint" *ngIf="MainPhotoPreview">До 1 Мб. Допустимые форматы: PNG, JPG, JPEG.</p>
            </div>
          </div>

          <div class="performers-create__field">
            <div class="ui-input__placeholder">
              <p>Фотогалерея</p>
            </div>
            <div class="performers-create__gallery-upload">
              <div
                class="performers-create__main-photo-zone performers-create__gallery-zone"
                [class.performers-create__main-photo-zone--dragover]="galleryDragOver"
                (click)="galleryInput.click()"
                (dragover)="onGalleryDragOver($event)"
                (dragleave)="onGalleryDragLeave($event)"
                (drop)="onGalleryDrop($event)"
              >
                <div class="performers-create__main-photo-zone-inner">
                  <div class="performers-create__main-photo-zone-icon">
                    <i class="pi pi-upload"></i>
                  </div>
                  <p class="performers-create__main-photo-zone-text">Загрузить фото в галерею</p>
                  <p class="txt-caption performers-create__main-photo-zone-hint">До 1 Мб. Допустимые форматы: PNG, JPG, JPEG.</p>
                </div>
              </div>
              <input type="file" class="performers-create__file-input" #galleryInput accept="image/png,image/jpeg,image/jpg" (change)="onGalleryChange($event.target.files, $event.target)">
            </div>
            <div class="performers-create__gallery mt-2" *ngIf="GalleryPreviews.length">
              <div *ngFor="let src of GalleryPreviews; let i = index" class="performers-create__gallery-item">
                <img [src]="src" alt="Превью">
                <button type="button" class="performers-create__gallery-item-remove" (click)="removeGalleryItem(i); $event.preventDefault()" [attr.aria-label]="'Удалить фото'">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="performers-create__field" id="performers-create-field-playlistLink">
            <div class="ui-input__placeholder">
              <p>Ссылка на плейлист</p>
            </div>
            <div class="ui-input ui-input__text" [class.error]="form.get('playlistLink').invalid && form.get('playlistLink').touched">
              <input type="url" formControlName="playlistLink" placeholder="https://vk.com/music/playlist/299117_79941310_490a4bffa68eac9ae2" title="Оформите плейлист с вашими хитами и укажите ссылку на VK">
            </div>
            <p class="ui-input__error" *ngIf="form.get('playlistLink').invalid && form.get('playlistLink').touched">
              Укажите ссылку на плейлист VK
            </p>
          </div>

          <div class="performers-create__content-subtitle mt-8"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">
            <h5>Букинг</h5>
          </div>

          <div class="performers-create__booking-fee">
              <div class="performers-create__booking-fee-head ui-input__placeholder">
                <p>Гонорар</p>
                <span class="require">*</span>
                <p class="error-holder" *ngIf="form.errors?.bookingRateRequired && formSubmitted">
                  Укажите сумму за час, сумму за сет или описание (договорная).
                </p>
              </div>
              <div class="performers-create__field" id="performers-create-field-pricePerHour">
                <div class="grid"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'align-items-end'}}">
                  <div class="col-6 col-sm-12"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pb-2' : 'pr-2'}}">
                    <div class="ui-input__placeholder">
                      <p>Сумма за час, руб</p>
                    </div>
                    <div class="ui-input ui-input__text"
                      [class.error]="form.get('pricePerHour').invalid && (form.get('pricePerHour').touched || formSubmitted)">
                      <input type="number" formControlName="pricePerHour" placeholder="" min="1" step="1">
                    </div>
                    <p class="error-holder" *ngIf="(form.get('pricePerHour').touched || formSubmitted) && form.get('pricePerHour').errors?.positiveAmount">
                      Укажите сумму больше 0 или оставьте поле пустым.
                    </p>
                  </div>
                  <div class="col-6 col-sm-12" id="performers-create-field-pricePerSet"
                    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pb-2' : 'pl-2 pr-0'}}">
                    <div class="ui-input__placeholder">
                      <p>Сумма за сет, руб</p>
                    </div>
                    <div class="ui-input ui-input__text"
                      [class.error]="form.get('pricePerSet').invalid && (form.get('pricePerSet').touched || formSubmitted)">
                      <input type="number" formControlName="pricePerSet" placeholder="" min="1" step="1">
                    </div>
                    <p class="error-holder" *ngIf="(form.get('pricePerSet').touched || formSubmitted) && form.get('pricePerSet').errors?.positiveAmount">
                      Укажите сумму больше 0 или оставьте поле пустым.
                    </p>
                  </div>
                </div>
              </div>
              <div class="performers-create__field" id="performers-create-field-bookingDescription">
                <div class="ui-input__placeholder">
                  <p>Договорная</p>
                  <p class="error-holder" *ngIf="form.get('bookingDescription').invalid && form.get('bookingDescription').touched">
                    {{ form.get('bookingDescription').errors?.maxlength ? 'Не более 300 символов' : '' }}
                  </p>
                </div>
                <div class="ui-input ui-input__text" [class.error]="form.get('bookingDescription').invalid && form.get('bookingDescription').touched">
                  <textarea formControlName="bookingDescription" class="performers-create__textarea-booking" placeholder="Краткое описание" maxlength="300" rows="3"></textarea>
                </div>
                <p class="pt-1 txt-helper">Доступно символов для ввода: {{ bookingDescriptionLimit }}</p>
              </div>
            </div>
              <div class="performers-create__field" id="performers-create-field-bookingAvailabilityText">
              <div class="ui-input__placeholder">
                <p>Текст доступности букинга</p>
              </div>
              <div class="ui-input ui-input__text">
                <input type="text" formControlName="bookingAvailabilityText" placeholder="Доступен с четверга по субботу" maxlength="100">
              </div>
            </div>

          <div class="performers-create__actions">
            <button type="button" class="ui-buttons ui-buttons__light-large" (click)="onPreview()" [disabled]="submitLoading">
              Предпросмотр
            </button>
            <button type="submit" class="ui-buttons ui-buttons__blue-large" [disabled]="form.invalid || submitLoading">
              Опубликовать
            </button>
          </div>
        </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog key="unsaved-form" appendTo="body" styleClass="p-dialog__confirm"></p-confirmDialog>
